import { render } from "./index.vue?vue&type=template&id=4b05c9ec&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4b05c9ec&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=4b05c9ec&lang=scss&scoped=true"

import exportComponent from "/root/workspace/sso-webclient_Xaij/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b05c9ec"]])

export default __exports__